import React, { useState } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, IconButton, InputAdornment } from "@mui/material";
import MapItTextField from "./MapItTextField";

const MapItPasswordTextField = ({ children, InputProps, ...props }) => {

    const [showPassword, setShowPassword] = React.useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };
    const [validationErrors , setValidationError] = useState({})
    return (
        <Box {...props?.containerProps}>
            <MapItTextField
                {...props}
                 error={!!validationErrors?.name}
              helperText={validationErrors?.name}
                type={showPassword ? 'text' : 'password'}
                InputProps={{
                        endAdornment: <InputAdornment position="end">
                            <IconButton
                                aria-label={
                                    showPassword ? 'hide the password' : 'display the password'
                                }
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                onMouseUp={handleMouseUpPassword}
                                edge="end"
                            >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>,
                        ...InputProps
                }}
            >
                {children}
            </MapItTextField>
        </Box>
    )
}

export default MapItPasswordTextField;
